import React from "react";
import { Card as MuiCard, Avatar as MuiAvatar, Chip } from "@mui/material";

export const Card = ({ children, className = "", onClick, sx = {} }) => (
  <MuiCard
    onClick={onClick}
    className={className}
    variant="outlined"
    sx={{
      boxShadow: (theme) => theme.shadows[1],
      borderRadius: 2,
      ...sx,
    }}
  >
    {children}
  </MuiCard>
);

export const Badge = ({ children, className = "", color = "default" }) => {
  // Map tailwind classes to MUI colors/styles roughly if needed,
  // but for now relying on the passed className or migrating usage.
  // Since the user asked to convert to MUI rules, we should try to use Chips where appropriate.
  // However, strict className usage might break. Let's return a styled span (Box) if we want to keep it simple
  // or a Chip if we want to be fully MUI.
  // Given the usage 'px-2.5 py-0.5', Chip size="small" is closest.

  return (
    <Chip
      label={children}
      size="small"
      className={className}
      sx={{
        height: "auto",
        "& .MuiChip-label": { px: 1, py: 0.5 },
        // Allow className to override or wrap
      }}
    />
  );
};

export const Avatar = ({ url, alt, size = "md", className = "" }) => {
  const sizeMap = { sm: 24, md: 32, lg: 40 };
  return (
    <MuiAvatar
      src={url}
      alt={alt}
      className={className}
      sx={{
        width: sizeMap[size] || 32,
        height: sizeMap[size] || 32,
        border: "1px solid",
        borderColor: "divider",
      }}
    />
  );
};
